import { TranslatePipe } from './../../../../shared/translate/pipes/translate.pipe';
import { ToastController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { ToastButton } from '@ionic/core';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    toast: HTMLIonToastElement;

    constructor(private toastController: ToastController, private translatePipe: TranslatePipe) { }

    async presentToast(msg: string, btnTxt?: string, handler?: any) {
        if (this.toast) {
            this.toast.dismiss();
        }
        this.toast = await this.toastController.create({
            keyboardClose: true,
            message: this.translatePipe.transform(msg),
            position: 'bottom',
            duration: 2000,
            buttons: [
                btnTxt ? this.getButton(btnTxt, handler) : '',
            ]
        });
        this.toast.present();
    }

    getButton(btnTxt: string, handler: any): ToastButton {
        return {
            side: 'end',
            cssClass: ['inc-toast-button'],
            text: this.translatePipe.transform(btnTxt),
            handler
        };
    }
}
